import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setMobileMenu } from '../../actions/header';

import './Header.css';

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      year: new Date().getFullYear(),
      width : window.innerWidth || document.documentElement.clientWidth,
      height : window.innerHeight|| document.documentElement.clientHeight
    }

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.props.setMobileMenu(!this.props.header.mobileMenu);
    if(!this.props.header.mobileMenu){
      document.body.classList.add('lock');
    }else{
      document.body.classList.remove('lock');
    }
  }

  render() {
    const { mobileMenu } = this.props.header;
    return (
      <header>
        <nav className={`navbar container-lg ${mobileMenu ? 'opened' : 'closed'}`}>
          <div className={`logo col-8 col-sm-3 ${mobileMenu ? 'opened' : 'closed'}`}>
            Usaproductos
          </div>
          <div className="menu col-4 col-sm-9">
            <ul>
              <a href="#how-it-works">
                <li>¿Cómo funciona?</li>
              </a>
              <a href="#testimonials">
                <li>¿Quienes Somos?</li>
              </a>
              <a href="#contact">
                <li>Contacto</li>
              </a>
            </ul>
            <div className={`toggle col-4 ${mobileMenu ? 'opened' : 'closed'}`}>
              <button onClick={this.toggleMenu}>
                <span className={`line first ${mobileMenu ? 'opened' : 'closed'}`}></span>
                <span className={`line small middle ${mobileMenu ? 'opened' : 'closed'}`}></span>
                <span className={`line last ${mobileMenu ? 'opened' : 'closed'}`}></span>
              </button>
            </div>
          </div>
          <div className={`mobile-menu ${mobileMenu ? 'opened' : 'closed'}`}>
            <div className="stripeContainer"></div>
            <ul className="" onClick={this.toggleMenu}>
              <a href="#how-it-works">
                <li>¿Cómo funciona?</li>
              </a>
              <a href="#testimonials">
                <li>¿Quienes Somos?</li>
              </a>
              <a href="#contact">
                <li>Contacto</li>
              </a>
            </ul>
            <div className="mobile-footer">
              <div className="row">
                <div className="col-7">
                  Usaproductos © {this.state.year}
                </div>
                <div className="col-5 social-networks">
                  <a rel="noopener noreferrer" href="https://www.facebook.com/Usaproductos1/" target="_blank" title="Usaproductos">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a rel="noopener noreferrer" href="https://www.instagram.com/usaproductos" target="_blank" title="Usaproductos">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  header: state.header,
});

const mapDispatchToProps = (dispatch) => ({
  setMobileMenu: (open) => dispatch(setMobileMenu(open))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js